import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';

export const redirectToMissingFeature = (
  router: Router,
  feature = 'userpicker',
) => {
  return new RedirectCommand(router.parseUrl(`/missing-feature/${feature}`), {
    state: { featureError: true },
  });
};
export const navigateToMissingFeature = (
  router: Router,
  feature = 'userpicker',
) => {
  void router.navigate(['/missing-feature', feature], {
    state: { featureError: true },
  });
};

/** The MissingFeature page is only reachable when explicitly navigate to with
 * specific router state. Otherwise, a root redirect is performed.
 *
 * It should be shown when:
 * - the userpicker API feature is not enabled.*/
export const canActivateMissingFeature: CanActivateFn = () => {
  const router = inject(Router);
  const validNavigation =
    router.getCurrentNavigation().extras?.state?.['featureError'] === true;
  if (validNavigation) {
    return validNavigation;
  }
  return router.createUrlTree(['/']);
};
